import { InjectionToken } from '@angular/core';

export const REFRESH_API_CONFIG = new InjectionToken<string>(
  'Refresh API Config Per Deployment Environment'
);
